module.exports = __webpack_public_path__ + "img/Logo-ikon.blå.c9b4dc70.png";